import React from 'react';
import DancersStepContainer from '../../../../components/dancers/DancersStepContainer';
import { StepComponentProps } from '../../../../types/registration';

/**
 * DancersStep - Registration flow step for selecting dancers
 * Using the DancersStepContainer which now leverages the useDancersData hook
 * for better separation of concerns and code organization.
 */
const DancersStep: React.FC<StepComponentProps> = (props) => {
  // Simple pass-through to the DancersStepContainer
  return <DancersStepContainer {...props} />;
};

export default DancersStep; 